interface Props {
	size?: number | string;
	color?: string;
	duration?: number;
	paused?: boolean;
	className?: string;
	ariaLabel?: string;
}

export const IosSpinner = ({
	size = 24,
	color = '#6b7280', // Tailwind gray-500
	duration = 1.0,
	paused = false,
	className,
	ariaLabel = '',
}: Props) => {
	const s = typeof size === 'number' ? `${size}px` : size;
	const barsCount = 12;
	const barWidth = 2.6;
	const barHeight = 8;
	const centerX = 16;
	const centerY = 16;

	return (
		<svg
			viewBox="0 0 32 32"
			width={s}
			height={s}
			role="status"
			aria-label={ariaLabel}
			className={className}
			style={{ display: 'inline-block', verticalAlign: 'middle', pointerEvents: 'none' }}
		>
			<style>{`
        .ios-bar { fill: ${color}; opacity: .25; }
        @keyframes ios-fade { from { opacity: 1 } to { opacity: .25 } }
        .ios-anim { animation: ios-fade ${duration}s linear infinite; }
        ${paused ? `.ios-anim { animation-play-state: paused; }` : ''}
        @media (prefers-reduced-motion: reduce) {
          .ios-anim { animation: none !important; opacity: .8; }
        }
      `}</style>

			{Array.from({ length: barsCount }).map((_, i) => {
				const angle = (360 / barsCount) * i;
				const delay = -(duration / barsCount) * i; // stagger each bar
				return (
					<rect
						key={i}
						className="ios-bar ios-anim"
						x={centerX - barWidth / 2}
						y={centerY - 14} // place near top, then rotate around center
						width={barWidth}
						height={barHeight}
						rx={barWidth / 2}
						transform={`rotate(${angle} ${centerX} ${centerY})`}
						style={{ animationDelay: `${delay}s` }}
					/>
				);
			})}
		</svg>
	);
};
